import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'proportionality_inverted',
    dependencies: [
        'levels_maths/proportionality_simple'
    ]
})


function common (q, value, countA, countB) {
    q.addText(countA + ' -> ' + (countA * value))
    q.addText('ANSWER_HERE -> ' + (countB * value))
    q.answer = countB

    q.addBadChoices(
        countA,
        countA * value,
        countB * value,
        () => random.intBetween(1, 9)
    )
}



level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: {countA: 2, countB: 3, value: 20}},
            {1: {countA: 3, countB: 1, value: 11}},
            {1: {countA: 4, countB: 2, value: 100}},
            {all: [
                {countA: 2, countB: [1, 3, 4], value: [2, 3, 10, 11, 20, 22, 30, 100, 200]},
                {countA: 3, countB: [1, 2, 4], value: [2, 3, 10, 11, 20, 22, 30, 100, 200]},
                {countA: 4, countB: [1, 2, 3], value: [2, 3, 10, 11, 20, 22, 100, 200]}
            ]}
        ], function (choices) {
            common(q, choices.value, choices.countA, choices.countB)
        })
    },
    times: 4
})






export default level

